const preGameList = [
    'Status Change - Warmup',
    'Cambio de Estatus — Calentamiento',
    'Status Change - In Progress',
    'Cambio de Estatus — En progreso',
    'Status Change - Pre-Game', 'Cambio de Estatus — Previo'
];

export default preGameList;
